// Core React libraries import
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Helmet } from 'react-helmet';

// Core ANTD libraries import
import { Alert, Row, Col } from 'antd';

// EZ web-app utils import
import { getNotification } from '../utils/ez_api//authUtil';
// EZ web-app components import
import { LogoImg } from '../components/social/LogoImg';
// EZ web-app pages import
import { RegisterByEmail } from './auth/registerByEmail';
// EZ web-app styles import
import '../styles/login.scss';
import { loadSubscriptionListFromServer } from 'utils/paymentUtil';
import { STRIPE_PUBLISHABLE_KEY } from 'utils/envUtil';
import { GTMUtil } from 'utils/gtmUtil';

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

// 1. Define your Ant-Design–inspired appearance
const appearance: any = {
    variables: {
        fontFamily: "'Nunito Sans', sans-serif",
        fontSizeBase: '14px',
        // colorText: '#262626',
        colorPlaceholder: '#8c8c8c',
        borderRadius: '6px',
        colorBackground: '#fff',
        colorPrimary: '#096dd9',
        colorDanger: '#f5222d',
        spacingUnit: '2px',
        padding: '4px 11px',
        // Add more variables as needed
    },
    rules: {
        '.Input': {
            border: '1px solid #d9d9d9',
            borderRadius: '6px',
            padding: '4px 11px',
            height: '40px',
            boxSizing: 'border-box',
            lineHeight: '1.5715',
            boxShadow: 'none',
        },
        '.Label': {
            fontFamily: "'Nunito Sans', sans-serif",
            fontWeight: '700',
            fontSize: '14px',
            lineHeight: '22px',
            marginTop: '20px',
        },
    },
};

export interface LoginProps {
    handleResolve: any;
    handleReject: any;
    userLoggedIn: any;
    showNotification?: any;
}

export const Register = React.memo(function Login(props: any) {
    // const [isLoading, setIsLoading] = React.useState(false);
    const history = useHistory();
    const [notificationSuccess, setNotificationSuccess] = useState<string | null>(null);

    const elementsOptions = {
        appearance,
        fonts: [
            {
                family: 'Nunito Sans',
                cssSrc: 'https://fonts.googleapis.com/css?family=Nunito+Sans:400,700&display=swap',
            },
        ],
    };

    useEffect(() => {
        const isNotification = getNotification();
        setNotificationSuccess(isNotification);
        setTimeout(() => setNotificationSuccess(null), 3000);
        if (localStorage.getItem('jwt')) history.push('/home');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        loadSubscriptionListFromServer();
        GTMUtil.trackPageView('/register', 'Register - EZ Coordinator');

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Helmet>
                <title>Sign Up for EZ Coordinator | Real Estate Made Simple</title>
                <meta
                    name="description"
                    content="Create your account and explore our real estate transaction management platform. Start your free 14-day trial now."
                />
            </Helmet>
            <Elements stripe={stripePromise} options={elementsOptions}>
                <Row justify="center">
                    <Col
                        xs={{ offset: 0, span: 16 }}
                        sm={{ offset: 0, span: 16 }}
                        md={{ offset: 0, span: 12 }}
                        lg={{ offset: 0, span: 12 }}
                        xl={{ offset: 0, span: 10 }}
                    >
                        <div className="login-wrapper">
                            <div className="success-toaster">
                                {notificationSuccess ? (
                                    <Alert message={notificationSuccess} type="success" showIcon />
                                ) : (
                                    ''
                                )}
                            </div>
                            <div className="login-page">
                                <LogoImg />
                                <div className="login-register-wrapper pt-5">
                                    {/* <RegisterUser
                                handleResolve={handleLoginResolve}
                                handleReject={handleReject}
                                userLoggedIn={handleSignUp}
                                showNotification={showNotification}
                            /> */}
                                    <div className="mr-4 ml-4">
                                        <div className="login-title"> Register new account </div>
                                        <RegisterByEmail />
                                    </div>
                                    <div className="new-registration mt-4">
                                        <span>
                                            Already have an account?&nbsp;
                                            {/* <span className="login-link" onClick={showLogin}>
                                        Login
                                    </span> */}
                                            <Link to="/login">
                                                <span className="">Login</span>
                                            </Link>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Elements>
        </>
    );
});
